(() => {
  'use strict';
  // KIKI_ACQUISITION_ATTRIBUTION_V4: preserve verified acquisition across navigation.
  const FIRST = 'kp_attribution_first_v2';
  const LAST = 'kp_attribution_last_v2';
  const SENT = 'kp_attribution_sent_v2';
  const NOW = Date.now();
  const WINDOW = 30 * 24 * 60 * 60 * 1000;
  const clean = (value, max = 160) => String(value || '').replace(/[\r\n\t]+/g, ' ').trim().slice(0, max);
  const storage = name => { try { return window[name]; } catch (_) { return null; } };
  const local = storage('localStorage');
  const session = storage('sessionStorage');
  const get = (store, key) => { try { return JSON.parse(store?.getItem(key) || 'null'); } catch (_) { return null; } };
  const set = (store, key, value) => { try { store?.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = (store, key) => { try { store?.removeItem(key); } catch (_) {} };
  const sources = [
    ['chatgpt', ['chatgpt', 'openai'], ['chatgpt.com', 'chat.openai.com']],
    ['gemini', ['gemini'], ['gemini.google.com']],
    ['claude', ['claude'], ['claude.ai']],
    ['perplexity', ['perplexity'], ['perplexity.ai']],
    ['copilot', ['copilot'], ['copilot.microsoft.com']],
    ['grok', ['grok'], ['grok.com']],
    ['poe', ['poe'], ['poe.com']],
    ['you', ['you'], ['you.com']],
    ['mistral', ['mistral'], ['mistral.ai', 'chat.mistral.ai']],
    ['deepseek', ['deepseek'], ['deepseek.com', 'chat.deepseek.com']],
    ['meta-ai', ['meta-ai'], ['meta.ai']]
  ];
  const aiSources = new Set(sources.map(row => row[0]));
  const isDomain = (host, domain) => host === domain || host.endsWith('.' + domain);
  const classify = value => {
    const raw = clean(value).toLowerCase().replace(/^www\./, '');
    for (const [name, aliases, domains] of sources) {
      if (aliases.includes(raw) || domains.some(domain => isDomain(raw, domain))) return name;
    }
    for (const [name, domains] of [['pinterest',['pinterest.com','pin.it']], ['instagram',['instagram.com']], ['facebook',['facebook.com','fb.com']], ['tiktok',['tiktok.com']], ['youtube',['youtube.com','youtu.be']], ['bing',['bing.com']], ['shop',['shop.app']]]) {
      if (raw === name || domains.some(domain => isDomain(raw, domain))) return name;
    }
    if (raw === 'google' || /^(?:[a-z0-9-]+\.)?google\.(?:com|[a-z]{2}|com\.[a-z]{2}|co\.[a-z]{2})$/.test(raw)) return 'google';
    return raw;
  };
  let refHost = '';
  try {
    const host = new URL(document.referrer).hostname.replace(/^www\./, '').toLowerCase();
    if (host !== location.hostname.replace(/^www\./, '').toLowerCase()) refHost = clean(host);
  } catch (_) {}
  const params = new URLSearchParams(location.search);
  const creator = clean(params.get('kp_creator') || params.get('creator'));
  const affiliate = clean(params.get('kp_affiliate') || params.get('affiliate'));
  const raw = clean(params.get('utm_source') || (creator ? 'creator' : affiliate ? 'affiliate' : '') || refHost);
  const source = classify(raw);
  const touch = {
    source, source_raw: raw && raw !== source ? raw : '',
    ai_channel: aiSources.has(source) ? source : '', referrer_host: refHost,
    medium:clean(params.get('utm_medium')), campaign:clean(params.get('utm_campaign')),
    campaign_id:clean(params.get('utm_id')), content:clean(params.get('utm_content')),
    term:clean(params.get('utm_term')), creator, affiliate,
    pin:clean(params.get('kp_pin')), video:clean(params.get('kp_video')),
    board:clean(params.get('kp_board')), market:clean(params.get('kp_market')),
    locale:clean(params.get('kp_locale')), landing:clean(location.pathname || '/',400),
    acquired_at:NOW
  };
  const hasAcquisition = Boolean(source || creator || affiliate || touch.campaign || touch.content);
  const valid = data => data && Number.isFinite(data.acquired_at) && NOW - data.acquired_at >= 0 && NOW - data.acquired_at <= WINDOW;
  let first = get(local,FIRST);
  let last = get(session,LAST);
  if (!valid(first)) { first = null; remove(local,FIRST); }
  if (!valid(last)) { last = null; remove(session,LAST); }
  if (hasAcquisition) {
    last = touch;
    set(session,LAST,last);
    if (!first) { first = touch; set(local,FIRST,first); }
  }
  if (!last && first) last = first;
  if (!last) return;

  const annotate = form => {
    if (!form?.getAttribute || !(form.getAttribute('action') || '').includes('/cart/add')) return;
    const values = {'_Discovery Source':last.source,'_Discovery Landing':last.landing,
      '_Discovery Campaign':last.campaign,'_Discovery Content':last.content,'_Discovery Pin':last.pin};
    for (const [key,value] of Object.entries(values)) {
      if (!value) continue;
      const name = `properties[${key}]`;
      let input = form.querySelector(`input[name="${name}"]`);
      if (!input) { input = document.createElement('input'); input.type='hidden'; input.name=name; form.appendChild(input); }
      input.value=clean(value,key==='_Discovery Landing'?400:160);
    }
  };
  const annotateExisting = () => document.querySelectorAll('form[action*="/cart/add"]').forEach(annotate);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',annotateExisting,{once:true});
  else annotateExisting();
  document.addEventListener('submit',event=>annotate(event.target),true);

  const attributes = {kp_attribution_v:'4'};
  for (const [prefix,data] of [['first',first || last],['last',last]]) {
    for (const key of Object.keys(touch)) {
      if (key==='acquired_at') continue;
      attributes[`kp_${prefix}_${key}`]=clean(data[key],key==='landing'?400:160);
    }
  }
  const signature = JSON.stringify(attributes);
  if (get(session,SENT)===signature) return;
  const root = window.Shopify?.routes?.root || '/';
  fetch(root.replace(/\/?$/, '/')+'cart/update.js', {
    method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
    credentials:'same-origin',body:JSON.stringify({attributes})
  }).then(response=>{
    if (!response.ok) throw new Error('cart attribution update failed');
    set(session,SENT,signature);
    window.dataLayer=window.dataLayer || [];
    window.dataLayer.push({event:'kp_attribution_ready',kp_source:last.source,kp_ai_channel:last.ai_channel || '',kp_campaign:last.campaign || '',kp_pin:last.pin || ''});
    if (hasAcquisition && last.ai_channel) window.dataLayer.push({event:'kp_ai_referral',kp_ai_channel:last.ai_channel,kp_ai_source_raw:last.source_raw || last.referrer_host || '',kp_ai_landing:last.landing,kp_ai_market:last.market || '',kp_ai_locale:last.locale || document.documentElement.lang || ''});
  }).catch(()=>{});
})();
